<div class="mid-simple-dashboard-block-container h-100">
  <div class="title">
    <span *ngIf="title">{{ title }}</span>
  </div>
  <div class="content">
    <ng-content></ng-content>
  </div>
</div>
